
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.21 14.89A10 10 0 117 1.83m13.24 5.344a10 10 0 01.728 3.027c.021.257.031.386-.02.501a.525.525 0 01-.22.239c-.11.06-.25.06-.528.06h-8.4c-.28 0-.42 0-.527-.055a.5.5 0 01-.218-.218C11 10.62 11 10.48 11 10.2V1.8c0-.278 0-.417.06-.528a.525.525 0 01.239-.22c.115-.051.244-.041.5-.02a10 10 0 018.44 6.14z","stroke":"inherit","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    